/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import wizardStyle from "@/src/components/Form/wizardStyle";

const formHeaderWrapperStyle = {
  ...wizardStyle,
  headline: {
    textAlign: "center",
    fontWeight: "bold",
    color: "primary.main",
  },
};
export default formHeaderWrapperStyle;
